<template>
	<div class="sidebar" :class="{'visible': sidebarContent}">
		<div class="sidebar__body">
			<div class="sidebar__head">
				<h4 class="mb-0 weight-md" v-html="sidebarTitle"></h4>
				<i class="sidebar__close material-icons pointer" @click="close">close</i>
			</div>
			<div class="sidebar__content markdown" v-html="$filters.markdown(sidebarContent)"></div>
		</div>
		<div class="sidebar__scrum" @click="close"></div>
	</div>
</template>

<script>
import { useMiscStore } from '@/lib/store/misc'

export default {
	name: 'Sidebar',
	setup() {
		const miscStore = useMiscStore()

		return {
			miscStore
		}
	},
	computed: {
		sidebarTitle() {
			if (!this.miscStore.sidebar?.title) return null
			return this.miscStore.sidebar.title
		},
		sidebarContent() {
			if (!this.miscStore.sidebar?.content) return null
			return this.miscStore.sidebar.content
		},
	},
	methods: {
		close() {
			this.miscStore.unsetSidebar()
		},
		keydown(evt) {
			if (evt.key == 'Escape') {
				this.close()
			}
		},
	},
	watch: {
		sidebarContent(newVal, oldVal) {
			if (newVal) {
				document.addEventListener('keydown', this.keydown)
			} else {
				document.removeEventListener('keydown', this.keydown)
			}
		},
	},
}
</script>

<style scoped lang="scss">

.sidebar {
	height: 100svh;
	position: fixed;
	z-index: 0;
	width: 100vw;
	right: -100vw;
	pointer-events: none;
	transition: all 0ms linear;
	transition-delay: 300ms;

	&.visible {
		transition-delay: 0ms;
		pointer-events: all;
		right: 0;
		z-index: 21;
	}

	&__scrum {
		position: absolute;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0,0,0,0.2);
		z-index: 18;
		opacity: 0;
		transition: opacity 150ms linear;
		transition-delay: 150ms;

		.visible & {
			opacity: 1;
			transition-delay: 0ms;
		}
	}

	&__body {
		background-color: var(--color--background);
		border-bottom-left-radius: var(--border-radius);
		border-top-left-radius: var(--border-radius);
		bottom: 0;
		box-shadow: 0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15);
		max-width: 480px;
		padding: 0 1rem 1rem 1rem;
		position: absolute;
		right: 0;
		top: 0;
		width: 100%;
		z-index: 19;

		display: flex;
		flex-direction: column;

		transform: translateX(100%);
		transition: transform 150ms linear;
		transition-delay: 0;

		.visible & {
			transform: translateX(0);
		}
	}

	&__head {
		align-items: center;
		display: flex;
		flex-direction: row;
		padding: 1rem 0;
		width: 100%;
	}

	&__content {
		flex: 1;
		overflow-y: auto;
	}

	&__close {
		margin-left: auto;
	}

	:deep(table) {
		border-spacing: 0;
		border: 1px solid var(--color--border-light);
		border-bottom: 0;
		font-size: 0.95rem;

		th {
			border-bottom: 1px solid var(--color--border-light);
			padding: 0.25rem 0.35rem;
			text-align: left;
		}
		td {
			border-bottom: 1px solid var(--color--border-light);
			padding: 0.25rem 0.35rem;
		}
	}
}
</style>
